/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2PrototypesPasswordAccessByPrototypeIdAndTypeParams,
  PutV2PrototypesPasswordAccessByPrototypeIdAndTypeParams,
  PostV2PrototypesPasswordByPrototypeIdParams,
  PostV2PrototypesPasswordSwitchByPrototypeIdAndTypeParams,
  GetV2PrototypesPasswordByPrototypeIdAndTypeParams,
  GetV2PrototypesPasswordTokenByPrototypeIdParams,
  GetV2PrototypesPasswordProtectedByPrototypeIdAndTypeParams,
  GetV2PrototypesPasswordTokenByPrototypeIdQuery,
  PutV2PrototypesPasswordAccessByPrototypeIdAndTypeBody,
  PostV2PrototypesPasswordByPrototypeIdBody,
  PostV2PrototypesPasswordSwitchByPrototypeIdAndTypeBody,
  GetV2PrototypesPasswordAccessByPrototypeIdAndTypeResponse,
  PutV2PrototypesPasswordAccessByPrototypeIdAndTypeResponse,
  PostV2PrototypesPasswordByPrototypeIdResponse,
  PostV2PrototypesPasswordSwitchByPrototypeIdAndTypeResponse,
  GetV2PrototypesPasswordByPrototypeIdAndTypeResponse,
  GetV2PrototypesPasswordTokenByPrototypeIdResponse,
  GetV2PrototypesPasswordProtectedByPrototypeIdAndTypeResponse,
} from '../types';

export class PrototypePasswordManagement extends Controller {
  async getV2PrototypesPasswordAccessByPrototypeIdAndType<
    T extends GetV2PrototypesPasswordAccessByPrototypeIdAndTypeResponse,
    D,
    C
  >(
    {
      prototypeId,
      type,
    }: GetV2PrototypesPasswordAccessByPrototypeIdAndTypeParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/${prototypeId}/password/access/${type}`,
      axiosConfig
    );
  }

  async putV2PrototypesPasswordAccessByPrototypeIdAndType<
    T extends PutV2PrototypesPasswordAccessByPrototypeIdAndTypeResponse,
    D,
    C extends PutV2PrototypesPasswordAccessByPrototypeIdAndTypeBody
  >(
    body: C,
    {
      prototypeId,
      type,
    }: PutV2PrototypesPasswordAccessByPrototypeIdAndTypeParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/${prototypeId}/password/access/${type}`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesPasswordByPrototypeId<
    T extends PostV2PrototypesPasswordByPrototypeIdResponse,
    D,
    C extends PostV2PrototypesPasswordByPrototypeIdBody
  >(
    body: C,
    { prototypeId }: PostV2PrototypesPasswordByPrototypeIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/${prototypeId}/password`,
      body,
      axiosConfig
    );
  }

  async postV2PrototypesPasswordSwitchByPrototypeIdAndType<
    T extends PostV2PrototypesPasswordSwitchByPrototypeIdAndTypeResponse,
    D,
    C extends PostV2PrototypesPasswordSwitchByPrototypeIdAndTypeBody
  >(
    body: C,
    {
      prototypeId,
      type,
    }: PostV2PrototypesPasswordSwitchByPrototypeIdAndTypeParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/${prototypeId}/password/switch/${type}`,
      body,
      axiosConfig
    );
  }

  async getV2PrototypesPasswordByPrototypeIdAndType<
    T extends GetV2PrototypesPasswordByPrototypeIdAndTypeResponse,
    D,
    C
  >(
    { prototypeId, type }: GetV2PrototypesPasswordByPrototypeIdAndTypeParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/${prototypeId}/password/${type}`,
      axiosConfig
    );
  }

  async getV2PrototypesPasswordTokenByPrototypeId<
    T extends GetV2PrototypesPasswordTokenByPrototypeIdResponse,
    D,
    C
  >(
    { prototypeId }: GetV2PrototypesPasswordTokenByPrototypeIdParams,
    query: GetV2PrototypesPasswordTokenByPrototypeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/prototypes/${prototypeId}/password/token`, query),
      axiosConfig
    );
  }

  async getV2PrototypesPasswordProtectedByPrototypeIdAndType<
    T extends GetV2PrototypesPasswordProtectedByPrototypeIdAndTypeResponse,
    D,
    C
  >(
    {
      prototypeId,
      type,
    }: GetV2PrototypesPasswordProtectedByPrototypeIdAndTypeParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/prototypes/${prototypeId}/password/protected/${type}`,
      axiosConfig
    );
  }
}
